import React from 'react';
import PropTypes from 'prop-types';
import { Events, handleAnalytics } from '@foxcorp/delta-web-analytics';

import helperMarkdownToComponent from 'helpers/Data';
import { renderImage } from 'helpers/ImageHelper';
import NetworkImage from 'components/NetworkImage';

const Legal = props => {
  const { theme, legal, logo } = props;

  const onClickEvent = {
    'Privacy Policy': () => {
      handleAnalytics({ event: Events.PRIVACY_POLICY_PAGE_VIEW });
    },
  };

  return (
    <div className={theme.legalContainer}>
      <div className={theme.logoWrapper}>
        <NetworkImage alt="Fox Nation logo" url={logo} />
      </div>
      {helperMarkdownToComponent(legal, onClickEvent, {
        Paragraph: props => {
          const { children } = props;
          if (!children) return null;
          return <p className={theme.legalText}>{children}</p>;
        },
        Link: props => (
          // eslint-disable-next-line react/prop-types
          <a href={props.href} className={theme.legalLink} target="noopener noreferrer">
            {props.children}
          </a>
        ),
      })}
      <div className={theme.tagWrapper}>
        {renderImage({ src: '/static/images/TAG_Registered.png', alt: 'Verified by TAG' })}
      </div>
    </div>
  );
};

Legal.propTypes = {
  children: PropTypes.shape({}),
  legal: PropTypes.string,
  logo: PropTypes.string,
  theme: PropTypes.shape({}),
};

export default Legal;
